import { IAuth } from "../auth/auth";
import { Axios } from "../axios";

export const createOfflineRemitter = async (currentUser: IAuth.IIsAuthorisedProps, body: any) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(`/remit/auth/user/${currentUser.vendor_key}/signupOffline`, body, {
      headers: {
        Authorization: `Bearer ${currentUser.idToken}`,
      },
    });
  }
};

export const addOfflineRecipient = async (
  offlineRemitter: any,
  currentUser: IAuth.IIsAuthorisedProps,
  body: any,
) => {
  if (offlineRemitter !== null && offlineRemitter !== undefined) {
    return await Axios.post(`/remit/user/${offlineRemitter.user_key}/recipients`, body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const initializeTransaction = async (
  offlineRemitter: any,
  currentUser: IAuth.IIsAuthorisedProps,
  body: any,
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(`/remit/user/${offlineRemitter.user_key}/initializeTransaction`, body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const offlineA2FormUpload = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=A2-Form&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineSelfDeclaration = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Self-Declaration&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineRelationShipProof = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Relationship-Proof&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineStudentPassport = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineBeneficiaryId = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Beneficiary-Id&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const uploadOfflineDocument = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
  docType: string,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=${docType}&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineLoanLetter = async (currentUser: IAuth.IIsAuthorisedProps, body: FormData) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Loan-Sanction-letter&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineInstructSheet = async (
  currentUser: IAuth.IIsAuthorisedProps,
  body: FormData,
) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Instruction-Sheet&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlinePaymentConf = async (currentUser: IAuth.IIsAuthorisedProps, body: FormData) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Payment-Confirmation&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlineOffer = async (currentUser: IAuth.IIsAuthorisedProps, body: FormData) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=University-Offer-Letter&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const offlinePAN = async (currentUser: IAuth.IIsAuthorisedProps, body: FormData) => {
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Pan&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    },
  );
};

export const getTransactionSummary = async (body: any) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/user/getTransactionSummary", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const uploadDocs = async (
  currentUser: IAuth.IIsAuthorisedProps,
  txnNo: string,
  body: any,
) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(
      `/remit/user/${currentUser.vendor_key}/transaction/${txnNo}/transactionDoc`,
      body,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      },
    );
  }
};

export const uploadUTRNumber = async (currentUser: IAuth.IIsAuthorisedProps, body: any) => {
  return await Axios.post(`/remit/user/${currentUser.vendor_key}/paymentRefrenceNum`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const getOfflineRecipients = async (
  currentUser: IAuth.IIsAuthorisedProps,
  offlineRemitter: any,
) => {
  return await Axios.get(`/remit/user/${offlineRemitter.user_key}/recipients`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const offlineAddRecipient = async (idToken: any, userToken: any, body: any) => {
  return await Axios.post(`/remit/user/${userToken}/recipients`, body, {
    headers: {
      Authorization: `${idToken}`,
    },
  });
};

export const offlineUpdateReference = async (idToken: any, userToken: any, body: any) => {
  return await Axios.post(`/remit/user/${userToken}/updateReference`, body, {
    headers: {
      Authorization: `${idToken}`,
    },
  });
};
